import { TranslateService } from '@ngx-translate/core';
import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, HostListener } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService } from 'shared-components';
import { EtiquetadoService } from '../../../services/etiquetado.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { formatDate } from "@angular/common";
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';

@Component({
    selector: 'app-mantenimientoDesignaciones-new-edit',
    templateUrl: './new-edit.component.html'
})
export class MantenimientoDesignacionesNewEditComponent implements OnInit, OnDestroy {

    private _desginacion;

    public cultivos;
    public campanyas;
    public paises;
    public denominaciones;
    public almacenes;
    public almacenesAsociados = [];
    public designaciones = [];

    public newForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();

    public gridCultivos = true;
    public aforoDisponible;
    public aforoCultivo;
    public porcentajeAforoDisponible = 0;
    public oldKilosADesignar;
    public oldAforoDisponible;
    public cultivoId;
    public marcaId;
    public designacionId;
    public columns = [this._translate.instant('global.finca'),
    this._translate.instant('mantenimientoDesignaciones.comboFinca.productor'),
    this._translate.instant('mantenimientoDesignaciones.comboFinca.ggn'),
    this._translate.instant('global.municipio'),
    this._translate.instant('global.provincia'), /*'Polígono Catastral', 'Parcela Catastral',*/
    this._translate.instant('mantenimientoDesignaciones.comboFinca.superficie'),
    this._translate.instant('mantenimientoDesignaciones.comboFinca.plantas'),
    this._translate.instant('mantenimientoDesignaciones.comboFinca.aforo'),
    this._translate.instant('mantenimientoDesignaciones.comboFinca.marca'),
    this._translate.instant('mantenimientoDesignaciones.comboFinca.aforoMarca')];

    public properties = ['des', 'strProductores', 'ggn', 'desMunicipio', 'desProvincia',
                        /*'poligonoCatastral', 'parcelaCatastral',*/ 'superficie', 'nPlantas', 'aforoCultivo',
        'desMarca', 'aforoMarca'];

    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledCultivos: Subject<boolean> = new Subject();
    public disabledAlmacenes: Subject<boolean> = new Subject();
    public disabledPaises: Subject<boolean> = new Subject();

    public checkboxes;
    public toCloseSpinner = 0;

    private readonly destroy$ = new Subject<void>();

    public showAlmacenes = false;
    public capacidadModal = false;
    public deleteModal = false;
    public etiquetaDigitalModal = false;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (event.target.id === "openCultivos" && this.gridCultivos === false) {
            this.gridCultivos = true;
        } else if (event.target.id !== "openCultivos" && event.target.id !== "gridCultivos" && this.gridCultivos === true) {
            this.gridCultivos = false;
        }
    }

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _translate: TranslateService,
        private readonly _dataProvider: DataProvider,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _sessionContext: SessionContextService
    ) { }

    ngOnInit() {
        this.newForm = this._fb.group({
            fechaDesignacion: [{ value: '' }, Validators.required],
            cultivo: [{ value: '', disabled: true }, Validators.required],
            //campanya: [{ value: '', disabled: true }, Validators.required],
            pais: [{ value: '', disabled: true }, Validators.required],
            denominacion: [{ value: '', disabled: true }, Validators.required],
            marca: [''],
            etiquetador: ['', Validators.required],
            cantidad: [{ value: '', disabled: true }, Validators.required],
            aforo: [{ value: '', disabled: true }],
            aforoDisponible: [''],
            almacenes: [{ value: true, disabled: true }, Validators.required],
            almacen: [{ value: '', disabled: true }],
            etiquetaDigital: [false]
        });

        this.newForm.patchValue({
            fechaDesignacion: new Date()
        })

        this.newForm.get('etiquetador').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((etiquetador) => {
            if (etiquetador) {

                let filters = {
                    etiquetadorId: etiquetador.etiquetadorId
                };

                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getPaisByEtiquetador(filters).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.paises = resp.lista;
                        if (this.paises.length === 1) {
                            this.newForm.get('pais').patchValue(this.paises[0]);
                            this.newForm.get('pais').disable();
                            this.disabledPaises.next(true);
                        } else {
                            this.newForm.get('pais').enable();
                            this.disabledPaises.next(false);
                        }
                    }
                });

                let _filtersDropDown = {
                    etiquetadorId: etiquetador.etiquetadorId
                };

                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getAlmacenesByMunicipioId(_filtersDropDown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    this.almacenes = resp.lista;
                    if (resp.lista.length >= 2) {
                        this.disabledAlmacenes.next(false);
                        this.newForm.get('almacenes').enable();
                    }
                });
            } else {
                this.paises = null;
                this.campanyas = null;
                this.denominaciones = null;
                this.cultivos = null;
                this.almacenes = null;
                this.disabledPaises.next(true);
                this.disabledDenominaciones.next(true);
                this.disabledCultivos.next(true);
                this.disabledAlmacenes.next(true);
                this.newForm.get('pais').reset();
                this.newForm.get('denominacion').reset();
                this.newForm.get('cultivo').reset();
                this.newForm.get('almacenes').patchValue(true);
                this.newForm.get('almacenes').disable();
            }
        });

        this.newForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                let filters = {
                    etiquetadorId: this.newForm.get('etiquetador').value.etiquetadorId,
                    paisId: pais.id,
                    impresionAutorizada: true
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getAllDenominacionesByPaisYEtiquetador(filters).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.denominaciones = resp.lista;
                        if (this.denominaciones.length === 1) {
                            this.newForm.get('denominacion').patchValue(this.denominaciones[0]);
                            this.newForm.get('denominacion').disable();
                            this.disabledDenominaciones.next(true);
                        } else {
                            this.newForm.get('denominacion').enable();
                            this.disabledDenominaciones.next(false);
                        }
                    }
                });
            } else {
                this.denominaciones = [];
                this.disabledDenominaciones.next(true);
                this.newForm.get('denominacion').patchValue('');
                this.newForm.get('denominacion').disable();
            }
        });

        this.newForm.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                let filters = {
                    paisId: this.newForm.get('pais').value.id,
                    denominacionId: denominacion.id,
                    habilitada: true
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getCampanyasByDenominacionId(filters).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.campanyas = resp.lista;
                        this._spinnerService.showSpinner();
                        this.toCloseSpinner += 1;
                        this._etiquetadoService.getCultivosAsociados(this.campanyas[0].id).toPromise().finally(() => {
                            this.checkCloseSpinner();
                        }).then((cultivos) => {
                            if (cultivos.length > 0) {
                                this.cultivos = cultivos;
                                this.disabledCultivos.next(false);
                                this.newForm.get('cultivo').enable();
                            }
                        });
                    }
                });
            } else {
                this.cultivos = null;
                this.newForm.get('cultivo').disable();
                this.disabledCultivos.next(true);
                this.newForm.get('cultivo').reset();
                this.oldAforoDisponible = 0;
                this.aforoDisponible = 0;
                this.porcentajeAforoDisponible = 0;
                this.newForm.get('aforoDisponible').reset();
            }
        });

        this.newForm.get('almacenes').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((almacen) => {
            if (almacen === false) {
                this.showAlmacenes = true;
            } else {
                this.showAlmacenes = false;
                this.almacenesAsociados = [];
            }
        });

        this.newForm.get('cultivo').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((cultivo) => {
            if (cultivo === '' || cultivo === null) {
                this.marcaId = null;
                this.cultivoId = null;
                this.newForm.get('marca').reset();
                this.oldAforoDisponible = 0;
                this.aforoDisponible = 0;
                this.porcentajeAforoDisponible = 0;
                this.newForm.get('aforoDisponible').reset();
                this.newForm.get('cantidad').reset();
                this.newForm.get('cantidad').disable();
            } else {
                this.oldKilosADesignar = 0;
                this.marcaId = cultivo.marcaId;
                this.cultivoId = cultivo.cultivoId;
                this.oldAforoDisponible = cultivo.aforoDisponible;
                this.aforoDisponible = cultivo.aforoDisponible;
                this.newForm.get('aforo').patchValue(cultivo.aforoCultivo);
                this.newForm.get('aforoDisponible').patchValue(cultivo.aforoDisponible);
                this.porcentajeAforoDisponible = (cultivo.aforoDisponible / cultivo.aforoCultivo) * 100
                this.newForm.get('marca').patchValue(cultivo.desMarca);
                this.newForm.get('cantidad').enable();
            }
        });

        this.newForm.get('cantidad').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((kilos) => {
            if (!this.newForm.get('cantidad').pristine) {
                this.newForm.get('aforoDisponible').setValue(this.aforoDisponible + (this.oldKilosADesignar - kilos));
                this.porcentajeAforoDisponible = (this.newForm.get('aforoDisponible').value / this.newForm.get('aforo').value) * 100;
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get rolePermission() {
        return this._sessionContext.sessionUser.role === 'Administrador';
    }

    public get marcas() {
        return this._dataProvider.marcasPaisDenominacion;
    }

    public get etiquetadores() {
        return this._dataProvider.etiquetadoresPais;
    }

    public confirmarCapacidad() {
        this.checkForm();

        if (this.newForm.invalid) {
            return;
        }

        if (this.newForm.get('cantidad').value > this.aforoDisponible) {
            this.capacidadModal = true;
        } else {
            // Mostramos el modal solo si se ha marcado el checkbox
            if (this.newForm.get('etiquetaDigital')?.value) {
                this.etiquetaDigitalModal = true;
            } else {
                this.mensajes = [];
                this.add();
            }
        }
    }

    public add() {
        this.etiquetaDigitalModal = false;
        if (this.capacidadModal) {
            this.capacidadModal = false;
            if (this.newForm.get('etiquetaDigital')?.value) {
                this.etiquetaDigitalModal = true;
                return;
            } else {
                this.mensajes = [];
            }
        }
        
        if (this.newForm.valid && !this.showError) {
            this._desginacion = {
                cultivoId: this.cultivoId,
                marcaId: this.marcaId,
                etiquetadorId: this.newForm.get('etiquetador').value.etiquetadorId,
                fecha: formatDate(this.newForm.get('fechaDesignacion').value, 'yyyy-MM-dd', 'en-GB'),
                cantidad: this.newForm.get('cantidad').value,
                lsAlmacenId: this.newForm.get('almacenes').value ? null : this.almacenesAsociados,
                esEtqDigital: this.newForm.get('etiquetaDigital').value
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._etiquetadoService.createDesignacion(this._desginacion).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.id) {
                    this.pushMessage('global.success.itemCreated');
                    this._spinnerService.showSpinner();
                    this.toCloseSpinner += 1;
                    this._etiquetadoService.getDesignacion(resp.id).toPromise().finally(() => {
                        this.checkCloseSpinner();
                    }).then((resp) => {
                        this.newForm.get('cantidad').reset();
                        this.aforoDisponible = this.aforoDisponible - this._desginacion.cantidad;
                        this.newForm.get('aforoDisponible').patchValue(this.aforoDisponible);
                        this.designaciones.push(resp);
                    });
                } else {
                    this.showError = true;
                    this.pushMessage('global.error.noResponse');
                }
            },
                (error) => {
                    this.showError = true;
                    let message;
                    if (error.status === 420) {
                        switch (error.error.ApiErrorCode) {
                          case 6073: // FechaFueraDeCampanya
                            message = this._translate.instant('ApiErrors.fechaFueraDeCampanya');
                            break;
                          case 3000: // FuncionalidadRestringida
                            message = this._translate.instant('ApiErrors.funcionalidadRestringida');
                            break;
                          case 3014: // EtiquetadorNoAccesible
                            message = this._translate.instant('ApiErrors.etiquetadorNoAccesible');
                            break;
                          case 5100: // CultivoNoAccesible
                            message = this._translate.instant('ApiErrors.cultivoNoAccesible');
                            break;
                          case 6005: // FincaPruebaOpAdmin
                            message =  this._translate.instant('ApiErrors.fincaPruebaOpAdmin');
                            break;
                          case 6006: // CultivoNoAccesibleParaEtiquetadorSeleccionado
                            message = this._translate.instant('ApiErrors.cultivoNoAccesibleParaEtiquetadorSeleccionado');
                            break;
                          case 6036: // CampanyaNoHabilitada
                            message = this._translate.instant('ApiErrors.campanyaHabilitada');
                            break;
                          case 6007: // MarcaPaisDenominacionNoAccesible
                            message = this._translate.instant('ApiErrors.marcaPaisDenominacionNoAccesible');
                            break;
                          case 6008: // CultivoMarcaNoAccesible
                            message = this._translate.instant('ApiErrors.cultivoMarcaNoAccesible');
                            break;
                          case 6009: // MarcaPaisDenominacionNoAccesibleParaEtiquetadorSeleccionado
                            message = this._translate.instant('ApiErrors.marcaPaisDenominacionNoAccesibleParaEtiquetadorSeleccionado');
                            break;
                          case 6166: // EtiquetadorCampanyaInactiva - solo insert
                            message = this._translate.instant('ApiErrors.etiquetadorCampanyaInactiva');
                            break;
                          case 4007: // FluentValidationGenerico
                            message = this._translate.instant('ApiErrors.fluentValidationGenerico');
                            break;
                          case 5101: // DesignacionNoAccesible
                            message = this._translate.instant('ApiErrors.designacionNoAccesible');
                            break;
                          case 5103: // AlmacenNoAccesible
                            message = this._translate.instant('ApiErrors.almacenNoAccesible');
                            break;
                          case 6074: // DesignacionAlmacenYaExiste
                            message = this._translate.instant('ApiErrors.designacionAlmacenYaExiste');
                            break;
                          case 6097: // DesignacionAlmacenDiferenteEtiquetador
                            message = this._translate.instant('ApiErrors.designacionAlmacenDiferenteEtiquetador');
                            break;
                          default:
                            message = this._translate.instant('ApiErrors.serverError');
                            break;
                        }
                    } else {
                        message = this._translate.instant('ApiErrors.serverError');
                    }
                    this.mensajes.push({ class: 'warning', message: message });
                });
        }
    }

    public addDesignacionPrueba() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.createDesignacionPrueba().toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.pushMessage('global.success.itemCreated');
        },
            (error) => {
                this.showError = true;
                this.pushMessage('global.error.noResponse');
            });
    }

    public delete() {
        this._spinnerService.showSpinner();
        const index = this.designaciones.indexOf(this._desginacion);
        if (index > -1) {
            this.designaciones.splice(index, 1);
        }
        this._etiquetadoService.deleteDesignacion(this.designacionId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.deleteModal = false;
            this.aforoDisponible = this.aforoDisponible + this._desginacion.cantidad;
            this.newForm.get('aforoDisponible').patchValue(this.aforoDisponible);
            this.porcentajeAforoDisponible = (this.newForm.get('aforoDisponible').value / this.newForm.get('aforo').value) * 100;
            this.pushMessage('global.success.itemDeleted');
        });
    }

    public askDelete(designacion) {
        this.designacionId = designacion.id;
        this._desginacion = designacion;
        this.deleteModal = true;
    }

    private checkForm() {
        this.showError = this.newForm.invalid;
        if (this.showError) {
            this.pushMessage('global.error.required');
        }
    }

    public pushMessage(mensaje) {
        if (mensaje.includes('req') || mensaje.includes('ApiErrors')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else if (mensaje.includes('Cre')) {
            this.mensajes.push({ class: 'success', message: mensaje });
        } else if (mensaje.includes('noR')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else if (mensaje.includes('Del')) {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }

    public close() {
        if (this.designaciones.length > 0) {
            this.refresh.emit(true);
        } else {
            this.refresh.emit(false);
        }
    }

    public cleanCultivo() {
        this.cultivoId = null;
        this.newForm.get('cultivo').reset();
        this.newForm.get('marca').reset();
    }

    public setCultivo(cultivo) {
        this.cultivoId = cultivo.cultivoId;
        this.marcaId = cultivo.marcaId;
        this.aforoDisponible = cultivo.aforoDisponible;
        this.aforoCultivo = cultivo.aforoCultivo;
        this.newForm.get('cultivo').patchValue(cultivo.desFinca);
        this.newForm.get('marca').patchValue(cultivo.marcaId);
    }

    public cancelAlmacenes() {
        this.almacenesAsociados = [];
        this.newForm.get('almacenes').patchValue(true);
    }

    public addAlmacenes(event: any) {
        if (event.target.checked) {
            this.almacenesAsociados.push(event.target.id);
        } else {
            const index = this.almacenesAsociados.indexOf(event.target.id);
            if (index > -1) {
                this.almacenesAsociados.splice(index, 1);
            }
        }
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }
}
